import { render, staticRenderFns } from "./WaitForJudgeToReview.vue?vue&type=template&id=ce2a4554"
import script from "./WaitForJudgeToReview.vue?vue&type=script&lang=ts"
export * from "./WaitForJudgeToReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports